(function () {
    'use strict';
    function cookieNamed(name) {
        var re = new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)');
        var match = document.cookie.match(re);
        return match ? decodeURIComponent(match[1]) : '';
    }

    function getCsrfToken() {
        var host = cookieNamed('__Host-abcd_csrf');
        var legacy = cookieNamed('abcd_csrf');
        if (window.location.protocol === 'https:') {
            return host || legacy;
        }
        return legacy || host;
    }

    var _origFetch = window.fetch;
    window.fetch = function (input, init) {
        var method = ((init && init.method) || 'GET').toUpperCase();
        if (method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH') {
            init = Object.assign({}, init);
            var headers = init.headers;
            if (!headers) {
                headers = {};
            } else if (typeof headers.set === 'function') {
                var plain = {};
                headers.forEach(function (v, k) { plain[k] = v; });
                headers = plain;
            } else {
                headers = Object.assign({}, headers);
            }
            if (!headers['X-CSRF-Token'] && !headers['x-csrf-token']) {
                var token = getCsrfToken();
                if (token) headers['X-CSRF-Token'] = token;
            }
            init.headers = headers;
        }
        return _origFetch.call(this, input, init);
    };

    document.addEventListener('htmx:configRequest', function (e) {
        var method = (e.detail.verb || 'GET').toUpperCase();
        if (method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH') {
            var token = getCsrfToken();
            if (token) e.detail.headers['X-CSRF-Token'] = token;
        }
    });

    function patchForm(form) {
        if (form.dataset.csrfPatched) return;
        form.dataset.csrfPatched = '1';
        form.addEventListener('submit', function () {
            var method = (form.getAttribute('method') || 'GET').toUpperCase();
            if (method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH') {
                if (!form.querySelector('input[name="csrf_token"]')) {
                    var token = getCsrfToken();
                    if (token) {
                        var inp = document.createElement('input');
                        inp.type = 'hidden';
                        inp.name = 'csrf_token';
                        inp.value = token;
                        form.appendChild(inp);
                    }
                }
            }
        });
    }

    function patchAllForms(root) {
        (root || document).querySelectorAll('form').forEach(patchForm);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { patchAllForms(); });
    } else {
        patchAllForms();
    }

    var _observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.tagName === 'FORM') patchForm(node);
                if (node.querySelectorAll) patchAllForms(node);
            });
        });
    });
    var _root = document.body || document.documentElement;
    if (_root) {
        _observer.observe(_root, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            _observer.observe(document.body, { childList: true, subtree: true });
        });
    }
})();
